import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as Highcharts from 'highcharts';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-project-wise-call-dashboard-two',
  templateUrl: './project-wise-call-dashboard-two.component.html',
  styleUrls: ['./project-wise-call-dashboard-two.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class ProjectWiseCallDashboardTwoComponent implements OnInit {

  @ViewChild('table_4_2',{static:false}) table_4_2: ElementRef;
  @ViewChild('table_4_3',{static:false}) table_4_3: ElementRef;
  @ViewChild('table_4_4',{static:false}) table_4_4: ElementRef;
  @ViewChild('table_4_5',{static:false}) table_4_5: ElementRef;

  authToken = localStorage.getItem("token");
  // projectInfo = JSON.parse(localStorage.getItem('projectInfo'));
  // userInfo: any = JSON.parse(localStorage.getItem("userInfo"))

  callsReportData: any = {};

  totalCallsList: any;

  filterForm: FormGroup;
  isFilter: boolean = false;
  btnStatus: boolean = false;

  myDateRangePickerOptions = {
    dateFormat: 'dd-mm-yyyy'
  };

  currentDate = new Date();
  rowNowDate: any = new Date().toLocaleDateString();
  nowDate: any = new Date().toLocaleDateString().split('/');
  rowBackDate: any = new Date(this.currentDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString();
  backDate: any = new Date(this.currentDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString().split('/');

  //dateRange: any = { "beginDate": { "year": this.backDate[2], "month": this.backDate[1], "day": this.backDate[0] }, "endDate": { "year": this.nowDate[2], "month": this.nowDate[1], "day": this.nowDate[0] } }
  dateRange: any = ""
  dateRangeVal:any;
  leadCreationDateRangeVal:any;

  projects: any[] = []
  selectedProjects: any[] = []

  highcharts = Highcharts;

  showCallDuration: boolean = false;

  dateArr:any[]=[]
  dataArr:any[]=[]
  userStatsColumn:any = {}
  // dateArr:any[]=[

  //   '2023-03-01', 
  //   '2023-03-02',
  //   '2023-03-03',
  //   '2023-03-04',
  //   '2023-03-05',
  //   '2023-03-06',
  //   '2023-03-07',
  //   '2023-03-08',
  //   '2023-03-09',
  //   '2023-03-10',
  //   '2023-03-11',
  //   '2023-03-12',
  //   '2023-03-13',
  //   '2023-03-14',
  //   '2023-03-15',
  //   '2023-03-16',
  //   '2023-03-17',
  //   '2023-03-18',
  //   '2023-03-19',
  //   '2023-03-20',
  //   '2023-03-21',
  //   '2023-03-22',
  //   '2023-03-23',
  //   '2023-03-24',
  //   '2023-03-25',
  //   '2023-03-26',
  //   '2023-03-27',
  //   '2023-03-28',
  //   '2023-03-29',
  //   '2023-03-30',
  //   '2023-03-31',

  //   '2023-04-01', 
  //   '2023-04-02',
  //   '2023-04-03',
  //   '2023-04-04',
  //   '2023-04-05',
  //   '2023-04-06',
  //   '2023-04-07',
  //   '2023-04-08',
  //   '2023-04-09',
  //   '2023-04-10',
  //   '2023-04-11',
  //   '2023-04-12',
  //   '2023-04-13',
  //   '2023-04-14',
  //   '2023-04-15',
  //   '2023-04-16',
  //   '2023-04-17',
  //   '2023-04-18',
  //   '2023-04-19',
  //   '2023-04-20',
  //   '2023-04-21',
  //   '2023-04-22',
  //   '2023-04-23',
  //   '2023-04-24',
  //   '2023-04-25',
  //   '2023-04-26',
  //   '2023-04-27',
  //   '2023-04-28',
  //   '2023-04-29',
  //   '2023-04-30',

  //   '2023-05-01', 
  //   '2023-05-02',
  //   '2023-05-03',
  //   '2023-05-04',
  //   '2023-05-05',
  //   '2023-05-06',
  //   '2023-05-07',
  //   '2023-05-08',
  //   '2023-05-09',
  //   '2023-05-10',
  //   '2023-05-11',
  //   '2023-05-12',
  //   '2023-05-13',
  //   '2023-05-14',
  //   '2023-05-15',
  //   '2023-05-16',
  //   '2023-05-17',
  //   '2023-05-18',
  //   '2023-05-19',
  //   '2023-05-20',
  //   '2023-05-21',
  //   '2023-05-22',
  //   '2023-05-23',
  //   '2023-05-24',
  //   '2023-05-25',
  //   '2023-05-26',
  //   '2023-05-27',
  //   '2023-05-28',
  //   '2023-05-29',
  //   '2023-05-30',
  //   '2023-05-31',

  //   '2023-06-01', 
  //   '2023-06-02',
  //   '2023-06-03',
  //   '2023-06-04',
  //   '2023-06-05',
  //   '2023-06-06',
  //   '2023-06-07',
  //   '2023-06-08',
  //   '2023-06-09',
  //   '2023-06-10',
  //   '2023-06-11',
  //   '2023-06-12',
  //   '2023-06-13',
  //   '2023-06-14',
  //   '2023-06-15',
  //   '2023-06-16',
  //   '2023-06-17',
  //   '2023-06-18',
  //   '2023-06-19',
  //   '2023-06-20',
  //   '2023-06-21',
  //   '2023-06-22',
  //   '2023-06-23',
  //   '2023-06-24',
  //   '2023-06-25',
  //   '2023-06-26',
  //   '2023-06-27',
  //   '2023-06-28',
  //   '2023-06-29',
  //   '2023-06-30',

  //   '2023-07-01', 
  //   '2023-07-02',
  //   '2023-07-03',
  //   '2023-07-04',
  //   '2023-07-05',
  //   '2023-07-06',
  //   '2023-07-07',
  //   '2023-07-08',
  //   '2023-07-09',
  //   '2023-07-10',
  //   '2023-07-11',
  //   '2023-07-12',
  //   '2023-07-13',
  //   '2023-07-14',
  //   '2023-07-15',
  //   '2023-07-16',
  //   '2023-07-17',
  //   '2023-07-18',
  //   '2023-07-19',
  //   '2023-07-20',
  //   '2023-07-21',
  //   '2023-07-22',
  //   '2023-07-23',
  //   '2023-07-24',
  //   '2023-07-25',
  //   '2023-07-26',
  //   '2023-07-27',
  //   '2023-07-28',
  //   '2023-07-29',
  //   '2023-07-30',
  //   '2023-07-31',

  //   '2023-08-01', 
  //   '2023-08-02',
  //   '2023-08-03',
  //   '2023-08-04',
  //   '2023-08-05',
  //   '2023-08-06',
  //   '2023-08-07',
  //   '2023-08-08',
  //   '2023-08-09',
  //   '2023-08-10',
  //   '2023-08-11',
  //   '2023-08-12',
  //   '2023-08-13',
  //   '2023-08-14',
  //   '2023-08-15',
  //   '2023-08-16',
  //   '2023-08-17',
  //   '2023-08-18',
  //   '2023-08-19',
  //   '2023-08-20',
  //   '2023-08-21',
  //   '2023-08-22',
  //   '2023-08-23',
  //   '2023-08-24',
  //   '2023-08-25',
  //   '2023-08-26',
  //   '2023-08-27',
  //   '2023-08-28',
  //   '2023-08-29',
  //   '2023-08-30',
  //   '2023-08-31',
  // ]

  // dataArr:any[]=[
  //   1,3,7,9,11,99,88,65,7,10,25,17,55,14,35,96,87,78,69,20,51,42,33,24,15,26,37,48,59,60,71,
  //   30,29,28,27,26,25,24,23,22,21,20,19,18,17,16,15,14,13,12,11,10,9,8,7,6,5,4,3,2,1,
  //   1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,
  //   1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,
  //   1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,
  //   1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,
  // ]

  projectWiseLeadReportDetails: any;
  projectWiseLeadCount: any;
  projectWiseLeadSourceReport: any;
  projectWiseLeadSourceFBCampaignReport: any;
  projectWiseLeadSourceGoogleCampaignReport: any;
  projectWiseLeadUsersReport: any;

  myTableColumns_4_2: any[] = ["Source", "Total-Leads", "Client-Delivered", "Fresh", "V-Under-Review", "Verified", "Appointment-Proposed", "V-Not-interested", "V-Not-Responding", "V-Not-Available", "Callback", "Wrong-Number", "Interested", "Not-Interested", "Not-Responding", "Not-Available", "Contacted", "Follow-UP", "Site-Visit", "Closed-Won", "V-Hold", "V-Interested", "V-Follow-UP", "V-SV-Drop", "V-SV-Done", "V-Booking-Done"];

  myTableColumns_4_3: any[] = ["Source", "Total-Leads", "Client-Delivered", "Fresh", "V-Under-Review", "Verified", "Appointment-Proposed", "V-Not-interested", "V-Not-Responding", "V-Not-Available", "Callback", "Wrong-Number", "Interested", "Not-Interested", "Not-Responding", "Not-Available", "Contacted", "Follow-UP", "Site-Visit", "Closed-Won", "V-Hold", "V-Interested", "V-Follow-UP", "V-SV-Drop", "V-SV-Done", "V-Booking-Done"]

  myTableColumns_4_4: any[] = ["Source", "Total-Leads", "Client-Delivered", "Fresh", "V-Under-Review", "Verified", "Appointment-Proposed", "V-Not-interested", "V-Not-Responding", "V-Not-Available", "Callback", "Wrong-Number", "Interested", "Not-Interested", "Not-Responding", "Not-Available", "Contacted", "Follow-UP", "Site-Visit", "Closed-Won", "V-Hold", "V-Interested", "V-Follow-UP", "V-SV-Drop", "V-SV-Done", "V-Booking-Done"];

  myTableColumns_4_5: any[] = ['User', 'Assigned-Leads', "Client-Delivered", "Fresh", "V-Under-Review", "Verified", "Appointment-Proposed", "V-Not-interested", "V-Not-Responding", "V-Not-Available", "Callback", "Wrong-Number", "Interested", "Not-Interested", "Not-Responding", "Not-Available", "Contacted", "Follow-UP", "Site-Visit", "Closed-Won", "V-Hold", "V-Interested", "V-Follow-UP", "V-SV-Drop", "V-SV-Done", "V-Booking-Done"];


  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.setFilter()
    this.getProjects()

    this.filterForm.get('dateRange').valueChanges.subscribe(res => {
      //console.log(res)
      if (res == null) {
        this.callsReportData = {}
      }
    })

    this.filterForm.get('leadCreationDateRange').valueChanges.subscribe(res => {
      if (res == null) {
        this.leadCreationDateRangeVal = []
      } 
    })

  }

  getProjects() {
    this.serverService.projectsList(this.authToken).subscribe(data => {
      this.projects = data
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }


  setFilter() {
    this.filterForm = this._fb.group({      
      project: [[], Validators.compose([Validators.required])],
      dateRange: [[], Validators.compose([Validators.required])],
      leadCreationDateRange: [],
    })
  }

  filterSubmit() {

    this.isFilter = true;

    if (this.filterForm.invalid) {
      return false
    }

    if(this.filterForm.value.leadCreationDateRange == null){
      this.leadCreationDateRangeVal = []
    } else {
      this.leadCreationDateRangeVal = [this.filterForm.value.leadCreationDateRange.beginDate.year + '-' + this.filterForm.value.leadCreationDateRange.beginDate.month + '-' + this.filterForm.value.leadCreationDateRange.beginDate.day, this.filterForm.value.leadCreationDateRange.endDate.year + '-' + this.filterForm.value.leadCreationDateRange.endDate.month + '-' + this.filterForm.value.leadCreationDateRange.endDate.day]
    }

    if(this.filterForm.value.dateRange == null){
      this.dateRangeVal = []
    } else {
      this.dateRangeVal = [this.filterForm.value.dateRange.beginDate.year + '-' + this.filterForm.value.dateRange.beginDate.month + '-' + this.filterForm.value.dateRange.beginDate.day, this.filterForm.value.dateRange.endDate.year + '-' + this.filterForm.value.dateRange.endDate.month + '-' + this.filterForm.value.dateRange.endDate.day]
    }

    let body = {
      "project_ids": this.filterForm.value.project == null ? [] : [this.filterForm.value.project],
      //"date_range": [this.filterForm.value.dateRange.beginDate.year + '-' + this.filterForm.value.dateRange.beginDate.month + '-' + this.filterForm.value.dateRange.beginDate.day, this.filterForm.value.dateRange.endDate.year + '-' + this.filterForm.value.dateRange.endDate.month + '-' + this.filterForm.value.dateRange.endDate.day],
      "date_range": this.dateRangeVal,
      "last_vendor_status_updated_at_range": this.leadCreationDateRangeVal,
    }

    this.serverService.getProjectWiseCallsReport(body, this.authToken).subscribe(data => {
      //console.log(data)

      this.callsReportData = data;
      this.projectWiseLeadReportDetails = data.project_wise_lead_report_details[0];
      this.projectWiseLeadCount = data.project_wise_lead_count;

      this.dateArr = []
      this.dataArr = []

      data.project_wise_lead_count.forEach((item:any,i:any) => {
        //console.log(item)
        this.dateArr.push(item.date_value)
        this.dataArr.push(item.leads_count)
      });

      this.showCallDuration = true
      this.userStatsColumn = {
    
        chart: {
          type: 'line'
        },
        title: {
          text: '',
          align: ''
        },
        subtitle: {
          text: '',
          align: ''
        },
        xAxis: {
          categories: this.dateArr,
          title: {
            text: 'Date Range'
          },
          gridLineWidth: 1,
          lineWidth: 1,
          labels: {
            rotation: -45
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Number of Leads',
            align: 'middle'
          },
          labels: {
            overflow: 'justify'
          },
          gridLineWidth: 0
        },
    
        tooltip: {
          //valueSuffix: ' Calls',
          pointFormat: '<table><tr><td style = "color:{series.color};padding:0">{point.key} </td>' +
            '<td style = "padding:0"><b>Lead Count - {point.y}</b></td></tr></table>',
          shared: true,
          useHTML: true
        },
    
        plotOptions: {
          bar: {
            color: '#00C08D',
            borderRadius: '0%',
            dataLabels: {
              enabled: true
            },
            groupPadding: 0.1,
            pointWidth: 30
          },
          series: {
            color: 'green'
        }
        },
    
        credits: {
          enabled: false
        },
    
        legend: {
          enabled: false,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: false,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
          shadow: false
        },
    
        series: [{
          data: this.dataArr
        }]
    
      }

      this.projectWiseLeadSourceReport = data.project_wise_lead_source_report;
      this.projectWiseLeadSourceFBCampaignReport = data.project_wise_lead_source_fb_campaign_report;
      this.projectWiseLeadSourceGoogleCampaignReport = data.project_wise_lead_source_google_campaign_report;
      this.projectWiseLeadUsersReport = data.project_wise_lead_users_report;
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    })

  }


  filterLead() {
  }

  clear() {
    this.filterForm.reset()
    this.callsReportData = {}
  }

  exportAsExcel_4_2() {
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table_4_2.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '4-2-source-report.xlsx');
  }


  exportAsExcel_4_3() {
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table_4_3.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '4-3-facebook-campaign-report.xlsx');
  }

  exportAsExcel_4_4() {
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table_4_4.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '4-4-google-campaign-report.xlsx');
  }

  exportAsExcel_4_5() {
    const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table_4_5.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    XLSX.writeFile(wb, '4-5-assigned-users-report.xlsx');
  }


}
